import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import DocumentoLegalCard from './DocumentoLegalCard';

const DocumentoLegalKanbanColumn = ({
  column,
  documentos,
  onCardClick,
  onEditDoc,
  onDeleteDoc,
  onChangeEstado,
  formatCurrency,
  formatDate,
  activeId,
  activeDocEstado,
  allowedTargets,
}) => {
  const { setNodeRef, isOver } = useDroppable({ id: column.id });

  // Determine visual feedback during drag
  const isAllowed = allowedTargets.includes(column.id);
  const isDragging = activeId != null;
  const isSameColumn = activeDocEstado === column.id;

  let dropClass = '';
  if (isDragging && !isSameColumn) {
    dropClass = isAllowed ? 'drop-allowed' : 'drop-forbidden';
  }

  // Column total
  const totalMonto = documentos.reduce(
    (sum, doc) => sum + parseFloat(doc.monto_total || 0),
    0
  );

  return (
    <div
      className={`docleg-kanban-column ${dropClass} ${isOver && isAllowed ? 'drop-hover' : ''}`}
      ref={setNodeRef}
    >
      <div
        className="docleg-column-header"
        style={{ borderTopColor: column.color }}
      >
        <div className="docleg-column-title">
          <span>{column.icon}</span>
          <span>{column.label}</span>
          <span className="docleg-column-count">{documentos.length}</span>
        </div>
        <div className="docleg-column-total">
          {new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
          }).format(totalMonto)}
        </div>
      </div>

      <SortableContext
        items={documentos.map((d) => d.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="docleg-column-content">
          {documentos.length === 0 ? (
            <div className="docleg-column-empty">Sin documentos</div>
          ) : (
            documentos.map((doc) => (
              <DocumentoLegalCard
                key={doc.id}
                documento={doc}
                onCardClick={onCardClick}
                onEdit={onEditDoc}
                onDelete={onDeleteDoc}
                onChangeEstado={onChangeEstado}
                formatCurrency={formatCurrency}
                formatDate={formatDate}
              />
            ))
          )}
        </div>
      </SortableContext>
    </div>
  );
};

export default DocumentoLegalKanbanColumn;
